import dynamic from 'next/dynamic';
const SportsCard = dynamic(() => import('./SportsCard'));

export { SportsCard };
